module.exports = __webpack_public_path__ + "static/media/logo.06ece1ac.svg";